import { render, staticRenderFns } from "./SiderRouteContractor.vue?vue&type=template&id=40a8f5e0&scoped=true&"
import script from "./SiderRouteContractor.vue?vue&type=script&lang=js&"
export * from "./SiderRouteContractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a8f5e0",
  null
  
)

export default component.exports